@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.sector {
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease-out 0s;

  &Collapsed {
    border-top: 1px solid map.get(core.$colors, middleGrey);
    padding-top: 24px;
  }

  &Label {
    overflow: hidden;
    padding-bottom: 16px;
    padding-left: 24px;
    white-space: nowrap;
  }
}
